import { render } from "./AnnouncementImage.vue?vue&type=template&id=62df7354&scoped=true&ts=true"
import script from "./AnnouncementImage.ts?vue&type=script&lang=ts"
export * from "./AnnouncementImage.ts?vue&type=script&lang=ts"

import "./AnnouncementImage.scss?vue&type=style&index=0&id=62df7354&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62df7354"]])

export default __exports__